import { render, staticRenderFns } from "./radar.vue?vue&type=template&id=c7644530"
import script from "./radar.vue?vue&type=script&lang=js"
export * from "./radar.vue?vue&type=script&lang=js"
import style0 from "./radar.vue?vue&type=style&index=0&id=c7644530&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RadarList: require('/usr/src/app/components/RadarList.vue').default,RadarFilters: require('/usr/src/app/components/RadarFilters.vue').default})
